export const MERCHANDISE_PLACEHOLDER_IMAGE_URL = "/assets/No-Photo.svg";

const invalidImageSentinels = new Set(["null", "undefined"]);

const isValidImageUrl = (imageUrl?: string | null): imageUrl is string => {
	const normalizedImageUrl = imageUrl?.trim();

	return Boolean(normalizedImageUrl && !invalidImageSentinels.has(normalizedImageUrl.toLowerCase()));
};

export const getMerchandiseImageUrls = (images?: (string | null)[] | null) => {
	const validImages = images?.filter(isValidImageUrl) ?? [];

	return validImages.length > 0 ? validImages : [MERCHANDISE_PLACEHOLDER_IMAGE_URL];
};

export const getMerchandisePrimaryImageUrl = (images?: (string | null)[] | null) => {
	return getMerchandiseImageUrls(images)[0];
};
